import React from 'react';
import moment from 'moment';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from '../helpers/utils';

import { Card } from 'react-bootstrap';
import { Chart, Series, Export, ArgumentAxis, Label, Legend, Tooltip, ValueAxis } from 'devextreme-react/chart';

class barChartShopifyUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          getData: [],
          errorMessage: ""
        };
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Shopify/GetActiveUsersByShopifyDaily")
        let formatted = [];
        
        if(resp) {
            // Client sided method to fix time string, should be done on backend as its needed for two requests.
            resp.forEach(element => {
                let timeFormatted = moment(element.date).format("DD/MM/YYYY")
                formatted.push({ Date: timeFormatted, Count: element.count })
            })
            this.setState({ getData: formatted });
        }
    }

    render() {
        if(this.state.getData !== null) {
            return (
            <Card className="rounded-4">
                <Card.Body>
                <Card.Title className='clearfix'>
                    Shopify Users ({global.config.dashboard.range} Days)
                    <div className='float-end'>
                        <span className="fullscreen-link" onClick={() => {renderFullScreen("#chartUsers")}}>Full Screen</span>
                            <span> | </span>
                        <span className="fullscreen-link" onClick={() => {exportData("ShopifyUsers", this.state.getData, global.config.dashboard.range)}}>Export</span>
                    </div>
                </Card.Title>
                <Card.Subtitle>
                    Number of Active User Logins by day for the selected range
                </Card.Subtitle>
                <Chart id="chartUsers" dataSource={this.state.getData}>
                    <Legend visible={false} />
                    <Tooltip
                        enabled={true}
                        location="edge"
                        customizeTooltip={this.customizeTooltip}
                        zIndex={10000}
                    />
                    <ValueAxis valueType="numeric"/>
                    <Series
                    valueField="Count"
                    argumentField="Date"
                    name="Active Users"
                    type="bar"
                    color="#d505f5" />
                    <Export enabled={true} />
                    <ArgumentAxis>
                        <Label
                            wordWrap="break"
                            overlappingBehavior={"rotate"}
                        />
                    </ArgumentAxis>
                </Chart>
                </Card.Body>
            </Card>
            );
        }
    }

    customizeTooltip(arg) {
        return {
            text: ` ${arg.argumentText} \n <b>${arg.valueText} Sign-Ins</b>`,
        }
    }
}

export default barChartShopifyUsers;
